const Hero = ({ nomineesCount }: { nomineesCount: number }) => {
  return (
    <section className="hero">
      <div className="wrap">
        <div className="eyebrow">Édition 2026 · Votes ouverts</div>
        <h1>
          Trophées des<span className="accent">Véhicules Électriques</span>
        </h1>
        <div className="stats">
          <div className="stat">
            <div className="num">{nomineesCount}</div>
            <div className="lbl">Modèles nominés</div>
          </div>
          <div className="stat">
            <div className="num">2</div>
            <div className="lbl">Catégories</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
